module.exports = "/_next/static/images/GearedS-3a04fefa6efe27b058393618108b8351.png";